import router from "~/router";

export default {
  beforeMount(el, binding) {
    el.setAttribute("href", "#");
    el.addEventListener("click", (e) => {
      e.preventDefault();
      if (binding.value) {
        router.push(binding.value);
      }
    });
  }
};
